import { InterviewService } from "../../../../../services/InterviewService";
import Mobility from "../../components/Mobility";
import { order } from "../SmartSearchParammeter";

export default async function MobilitySearchConfig(key) {
  let mobilityTree = await InterviewService.getAllMobilityInterview();
  let mobility = [];
  mobilityTree.forEach((m) => {
    mobility.push({
      id: m.value,
      description: m.label.replace(/,/g, "#").trim()
    });
    m.children.forEach((c) => {
      mobility.push({
        id: c.value,
        description: c.label.replace(/,/g, "#").trim()
      });
    });
  });
  return {
    description: "Mobility",
    id: "mobility",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Mobility
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    operation: ["Can "],
    list: mobility.map((m) => m.description.replace(/,/g, "#").trim()),

    handler: function (searchObj, value) {
      let selected = mobility.filter((m) =>
        value.includes(m.description.replace(/,/g, "#"))
      );
      searchObj["mobility"] = selected.map((m) => m.id);
    }
  };
}
